import React from 'react';

const quizInstanceStatusContext = React.createContext(null);

export default quizInstanceStatusContext;